// Implementation inspired by https://github.com/appfigures/react-easy-emoji
import clsx from 'clsx';
import emojiRegex from 'emoji-regex';
import Image from 'next/image';
import React, { ReactNode } from 'react';
import replaceStringToArray from 'string-replace-to-array';

const RADIX = 16;
const RANGE_START = 0x10000;
const HIGH_SURROGATE_START = 0xd800;
const HIGH_SURROGATE_END = 0xdbff;
const LOW_SURROGATE_START = 0xdc00;
const BIT_SHIFT_LENGTH = 10;

const regExp = emojiRegex();
export const toCodePoint = (unicodeSurrogates: string) => {
  const result = [];
  let charCode = 0;
  let tempCharCode = 0;

  for (let i = 0; i < unicodeSurrogates.length; i++) {
    charCode = unicodeSurrogates.charCodeAt(i);
    if (tempCharCode) {
      result.push(
        (RANGE_START + ((tempCharCode - HIGH_SURROGATE_START) << BIT_SHIFT_LENGTH) + (charCode - LOW_SURROGATE_START)).toString(RADIX),
      );
      tempCharCode = 0;
    } else if (charCode >= HIGH_SURROGATE_START && charCode <= HIGH_SURROGATE_END) {
      tempCharCode = charCode;
    } else {
      result.push(charCode.toString(RADIX));
    }
  }
  return result.join('-');
};

export const replaceEmoji = (string: string, render: (code: string, string: string, key: string) => ReactNode) =>
  replaceStringToArray(string, regExp, (match, _, offset) => {
    const icon = toCodePoint(match);
    return render(icon, match, offset);
  });

export const Emoji: React.FC<{ text: string; alt?: string; className?: string }> = ({ text, alt, className }) => (
  <span className='flex items-center whitespace-pre-wrap'>
    {replaceEmoji(text, (code: string, string: string, key: string) => (
      <div className='shrink-0' key={key}>
        <Image
          alt={alt ?? string}
          height={16}
          src={`https://cdn.jsdelivr.net/npm/emoji-datasource-apple@14.0.0/img/apple/64/${code}.png`}
          width={16}
          className={clsx('h-4 w-4 shrink-0', className)}
        />
      </div>
    ))}
  </span>
);
